(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fb-product-video"] && !Shopify.designMode) return;
  try {
    
customElements.define(
  'fb-video-embed',
  class FbVideoEmbed extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.play.bind(this), { once: true });
    }

    play(event) {
      const trigger = event.target.closest('.fb-pv__poster');
      if (!trigger) return;

      const id = this.dataset.videoId;
      const provider = this.dataset.provider;
      if (!id) return;

      const src =
        provider === 'vimeo'
          ? `https://player.vimeo.com/video/${encodeURIComponent(id)}?autoplay=1&dnt=1&title=0&byline=0&portrait=0`
          : `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;

      const iframe = document.createElement('iframe');
      iframe.setAttribute('src', src);
      iframe.setAttribute('title', trigger.getAttribute('aria-label') || 'Video');
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      iframe.setAttribute('allowfullscreen', 'allowfullscreen');
      iframe.setAttribute('loading', 'lazy');

      trigger.remove();
      this.appendChild(iframe);
      iframe.focus();
    }
  }
);

  } catch(e) { console.error(e); }
})();
})();
